import React, {FC} from "react";
import {
    Box,
    Typography,
} from "@mui/material";
import {
    GarageDetailsAdditionalData,
    IGarageList,
} from "../../../interfaces/Interfaces";
import {BackButton} from "../../buttons/BackButton";
import {RoutesPath} from "../../../enums/RoutesPath";
import {GarageDetailsMap} from "./GarageDetailsMap";
import {GarageDetailsInfo} from "./GarageDetailsInfo";
import {GarageReviews} from "./GarageReviews";
import {RenderGaragePhoto} from "../RenderGaragePhoto";

interface Props {
    garage: IGarageList;
    details: GarageDetailsAdditionalData | null;
}

export const GarageDetailsCardMobile: FC<Props> = ({garage, details}) => {
    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                    mb: 2,
                }}
            >
                <Box sx={{position: "absolute", left: 0}}>
                    <BackButton fallbackUrl={RoutesPath.MOTO_GARAGES}/>
                </Box>
                <Typography variant="h6" component="h2">
                    {garage?.name}
                </Typography>
            </Box>
            <Box sx={{mb: 2}}>
                <GarageDetailsMap
                    latitude={garage.latitude}
                    longitude={garage.longitude}
                    height={200}
                />
            </Box>
            {garage.placePhoto && (
                <Box sx={{display: "flex", justifyContent: "center", mb: 2}}>
                    <RenderGaragePhoto value={garage.placePhoto} size={250} width={250} height={250}/>
                </Box>
            )}
            <Box sx={{mb: 2}}>
                <GarageDetailsInfo garage={garage} details={details}/>
            </Box>
            {details?.reviews && (
                <Box mt={2}>
                    <GarageReviews reviews={details.reviews}/>
                </Box>
            )}
        </>
    );
};
